import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.css']
})
export class PageNotFoundComponent implements OnInit {

  constructor() { }

  ngOnInit() {
     if (sessionStorage.getItem("login") === null) {
      window.location.href = "/";
    }
  }

}



// WEBPACK FOOTER //
// D:/TPL ILG/3PL_ILG/src/app/components/page-not-found/page-not-found.component.ts